import React from "react";
import { profilePictures } from "@/lib/data";
import { useWorkspaceStore } from "@/hooks/useWorkspace";
import { API_URL } from "@/env";
import { getCookie } from "@/lib/cookies";
import { showCustomToast } from "../CustomToast";
import useUserData from "@/hooks/useUserData";

const SettingsTeam = () => {
  const { currentWorkspace, setCurrentWorkspace } = useWorkspaceStore();
  const { user } = useUserData();
  const token = getCookie("token");

  const handleRemoveUser = async (memberId: string) => {
    try {
      const response = await fetch(
        `${API_URL}/workspaces/${currentWorkspace?._id}/users/${memberId}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (!response.ok) {
        throw new Error("Failed to update workspace name");
      }

      showCustomToast("User removed from workspace", "check");

      setCurrentWorkspace({
        ...currentWorkspace,
        //@ts-ignore
        users: currentWorkspace?.users.filter((user) => {
          return user._id !== memberId;
        }),
      });
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
      <div className="font-medium text-[16px] leading-[24px] text-gray-900">
        Members{" "}
        <span className="text-white/[0.24]">
          · {currentWorkspace?.users?.length}
        </span>
      </div>
      <div className="flex flex-col gap-[33px] mt-6">
        {currentWorkspace?.users?.map((member: any, i) => {
          return (
            <div
              key={member?._id}
              className="relative flex items-center justify-between gap-3"
            >
              <div className="relative flex gap-3 items-center">
                <img
                  src={profilePictures[member.profilePicture - 1]}
                  className="cursor-pointer border-[1px] w-[36px] h-[36px] border-white/[0.32] rounded-[50%]"
                />
                <div className="text-[14px] font-medium leading-[20px]">
                  <div className="">
                    <p className="inline text-gray-900">{member.username}</p>
                    {i === 0 && (
                      <p className="inline text-white/[0.24]">{` · Admin`}</p>
                    )}
                  </div>
                  <p className="text-white/[0.24] ">{member.email}</p>
                </div>
              </div>
              {user?._id === currentWorkspace?.users[0]._id && i !== 0 && (
                <button
                  onClick={() => handleRemoveUser(member._id)}
                  className="px-3 flex rounded-[12px] text-[14px] font-medium leading-[20px] items-center text-red-700 bg-red-alpha/[0.08] hover:bg-red-alpha/[0.16] justify-center h-[36px]"
                >
                  Remove
                </button>
              )}

              {i !== currentWorkspace?.users?.length - 1 && (
                <div className="absolute h-[1px] w-[calc(100%-28px)] right-[-20px] bg-white/[0.08] bottom-[-16px]" />
              )}
            </div>
          );
        })}
      </div>
    </>
  );
};

export default SettingsTeam;
